import { toNullableUuid } from "./uuidFields";

/**
 * Resolve project UUID fields for Manual Time Entry create/update payloads.
 * Empty "None Selected" UI state must become null (never "").
 * When the selected id is missing from the active projects list (e.g. archived),
 * preserve the existing log's name/client rather than wiping project_id to "".
 */
export function resolveManualTimelogProjectFields({
  formProjectId,
  projects = [],
  existingLog = null,
} = {}) {
  const projectId = toNullableUuid(formProjectId);
  const selectedProject = projectId
    ? projects.find((project) => project.project_id === projectId)
    : null;

  if (!projectId) {
    return {
      project_id: null,
      project_name: "None Selected",
      client_id: null,
    };
  }

  return {
    project_id: projectId,
    project_name:
      selectedProject?.project_name ||
      existingLog?.project_name ||
      "None Selected",
    client_id: toNullableUuid(
      selectedProject?.client_id ?? existingLog?.client_id,
    ),
  };
}

/**
 * Ensure save UI leaves the saving state even when the work throws.
 */
export async function runWithSavingState(setSaving, work) {
  setSaving(true);
  try {
    return await work();
  } finally {
    setSaving(false);
  }
}
